<!-- 活动倒计时组件 -->
<template>
  <div class="activity-cutdown medium" v-if="context && cutdownTime > 0">
    <div class="context">{{ context }}</div>
    <div class="time">
      <div class="icon"></div>
      {{ cutdownTime | formatTime }}
    </div>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  props: {
    context: {
      type: String,
      default: '',
    },
    cutdownTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.activity-cutdown {
  padding: 7px 8px;
  border-radius: 6px;
  background-color: rgba(254, 232, 240, 1);
  margin-bottom: 6px;
  color: rgba(255, 83, 121, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  .time {
    margin-left: 20px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    .bg-image('icon_cutdown');
  }
  .context {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
}
</style>
